import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp0020',
    ecrans: ['00-2']
});

